<template>
  <i v-if="wrap" class="icon-svg-wrapper">
    <svg
      :class="getClassName"
      :width="width"
      :height="height"
      aria-hidden="true">
      <use :xlink:href="getName"></use>
    </svg>
  </i>
  <svg
    v-else
    :class="getClassName"
    :width="width"
    :height="height"
    aria-hidden="true">
    <use :xlink:href="getName"></use>
  </svg>
</template>

<script>
export default {
  name: 'icon-svg',
  props: {
    name: {
      type: String,
      required: true
    },
    className: {
      type: String
    },
    width: {
      type: String
    },
    height: {
      type: String
    },
    iconfont: Boolean,
    wrap: Boolean
  },
  computed: {
    getName () {
      return this.iconfont ? `#${this.name}` : `#icon-${this.name}`
    },
    getClassName () {
      return [
        'icon-svg',
        `icon-svg__${this.name}`,
        this.className && /\S/.test(this.className) ? `${this.className}` : ''
      ]
    }
  }
}
</script>

<style lang="less">
.icon-svg-wrapper {
  width: 1em;
  position: relative;
  display: flex;
  align-items: center;
}
.icon-svg {
  width: 1em;
  height: 1em;
  fill: currentColor;
  overflow: hidden;
}
</style>
